import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { NavigationBuilder } from '../../../navigation/navigation.builder';
import { NavigationService } from '../../../navigation/navigation.service';
import { ScreenNamesEnum } from '../../../navigation/screen-names.enum';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingCanvasCategoryEnum,
  TrackingCanvasTypeEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import {
  DeepLinkTriggerActionsEnum,
  DeepLinkTypeEnum,
} from '../../../navigation/deep-link.enum';

export const DIALOG_TYPE = 'tax-year-filter';

@Component({
  selector: 'app-tax-year-filter-dialog',
  templateUrl: './tax-year-filter-dialog.component.html',
  styleUrls: ['./tax-year-filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxYearFilterDialogComponent implements OnInit {
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  dialogType: string;
  trackingObject: ITrackingObject;
  gotItTrackingAction: ITrackingAction;
  updateTaxYearTrackingAction: ITrackingAction;

  constructor(
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _navigationService: NavigationService,
    private _navigationBuilder: NavigationBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.trackingObject = this._trackingObjectBuilder.buildCanvas(
      'fiscal_year_change',
      TrackingCanvasTypeEnum.documents,
      TrackingCanvasCategoryEnum.action,
      'got_it',
      'update_fiscal_year'
    );
    this.gotItTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'got_it',
      this.trackingScreenName
    );
    this.updateTaxYearTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'update_fiscal_year',
      this.trackingScreenName
    );
  }

  navigateToTaxYearSettings() {
    this._navigationService.goToDeepLink(
      this._navigationBuilder.buildDeepLinkUrl(
        DeepLinkTypeEnum.internal,
        ScreenNamesEnum.update_tax_year,
        DeepLinkTriggerActionsEnum.navigate
      )
    );
  }
}
